import React from 'react';
import './Membership.css';

function CustomerMembership() {
  const membershipTiers = [
    {
      name: 'Silver',
      color: 'var(--tier-silver)',
      price: '$99',
      period: '/month',
      benefits: [
        'Member labor rate on every job',
        'Priority scheduling',
        'Quarterly maintenance reminders',
        'Basic support',
        'Online account management'
      ]
    },
    {
      name: 'Gold',
      color: 'var(--tier-gold)',
      price: '$199',
      period: '/month',
      popular: true,
      benefits: [
        'Member labor rate on every job',
        'Priority service',
        'Priority communication',
        'SeaTow membership included',
        'Monthly maintenance reminders',
        'Dedicated support line',
        'Complimentary vessel inspections'
      ]
    },
    {
      name: 'Diamond',
      color: 'var(--tier-diamond)',
      price: '$299',
      period: '/month',
      benefits: [
        'Member labor rate on every job',
        'Highest priority service',
        'Priority communication',
        'SeaTow membership included',
        'Weekly maintenance reminders',
        '24/7 concierge support',
        'Unlimited vessel inspections',
        'Free emergency haul-outs'
      ]
    }
  ];

  return (
    <div className="page-container membership-page">
      <div className="page-header">
        <h1>Membership</h1>
        <p className="subtitle">Upgrade your account for exclusive benefits</p>
      </div>

      {/* Current Status Section */}
      <div className="current-status-card">
        <div className="status-header">
          <h2>Current Status: No Membership</h2>
          <p>You can still enjoy these Poseidon Marine benefits:</p>
        </div>
        <div className="base-benefits">
          <div className="benefit-item">
            <span className="benefit-icon">⭐</span>
            <span className="benefit-text">Top tier service</span>
          </div>
          <div className="benefit-item">
            <span className="benefit-icon">💰</span>
            <span className="benefit-text">Transparent pricing</span>
          </div>
          <div className="benefit-item">
            <span className="benefit-icon">⏰</span>
            <span className="benefit-text">Service anytime</span>
          </div>
        </div>
      </div>

      {/* Membership Tiers */}
      <div className="membership-tiers-section">
        <h2 className="tiers-heading">Upgrade to a Membership Plan</h2>
        <p className="tiers-subtitle">Choose the plan that best fits your needs</p>
        <p className="tiers-subtitle">
          Members pay their plan's labor rate, which is never more than the regular rate. Parts are at the regular price.
        </p>

        <div className="membership-tiers">
          {membershipTiers.map((tier, index) => (
            <div key={index} className={`membership-card ${tier.popular ? 'popular' : ''}`}>
              {tier.popular && <div className="popular-badge">Most Popular</div>}
              <div className="membership-card-header" style={{ borderTopColor: tier.color }}>
                <h3 className="tier-name" style={{ color: tier.color }}>{tier.name}</h3>
                <div className="tier-price">
                  <span className="price">{tier.price}</span>
                  <span className="period">{tier.period}</span>
                </div>
              </div>
              <div className="membership-card-body">
                <ul className="benefits-list">
                  {tier.benefits.map((benefit, benefitIndex) => (
                    <li key={benefitIndex} className="benefit-item-list">
                      <span className="check-icon">✓</span>
                      <span>{benefit}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="membership-card-footer">
                <button className="btn-upgrade" style={{ backgroundColor: tier.color }}>
                  Upgrade to {tier.name}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default CustomerMembership;
